import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';

import {HandoverNotificationsService} from "@handover/routes/main-route/services/handover-notifications.service";
import {HandoverHttpService} from "@handover/http-services/handover-http.service";
import { NotificationService } from '@commons/services/notification/notification.service';

@Component({
  selector: 'handovermod-worker-statement',
  templateUrl: './worker-statement.component.html',
})
export class WorkerStatementComponent implements OnInit {

  isLoading = true;
  isSaving = false;
  public maxLengthRegulations: number = 30000;

  public form = this.formBuilder.group({
    text: new FormControl('', [Validators.required])
  });

  constructor(
    private formBuilder: FormBuilder,
    private handoverNotificationsService: HandoverNotificationsService,
    private handoverHttpService: HandoverHttpService,
    private translate: TranslateService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.handoverHttpService.getStatement().subscribe(
      statement => {
        this.form.controls.text.setValue(statement);
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  public onSave(): void {
    if (!this.isValidRegulationText()) {
      alert(this.translate.instant('handover.max-length-regulations-error', { value: this.maxLengthRegulations }));
      return;
    }

    this.isSaving = true;
    const statement = this.form.controls.text.value?.trim() ?? '';
    this.handoverHttpService.setStatement(statement).subscribe(
      () => {
        this.onSuccessSaveRegulations();
      },
      () => {
        this.isSaving = false;
        this.notificationService.showError('Wystąpił problem, spróbuj jeszcze raz.');
      },
    );
  }

  onGoToList() {
    this.handoverNotificationsService.isWorkerStatementVisible$.next(false);
  }

  onCancel() {
    this.handoverNotificationsService.isWorkerStatementVisible$.next(false);
  }

  private isValidRegulationText(): boolean {
    const { text } = this.form.value;
    const ifTextLengthValid = (text && text?.length <= this.maxLengthRegulations);

    if (!text || ifTextLengthValid) {
      return true;
    }
    return false;
  }

  private onSuccessSaveRegulations(): void {
    this.isSaving = false;
    this.notificationService.showSuccess('Poprawnie zapisano regulamin.');
    this.onGoToList();
  }

}
